import { api } from "@//api";
import { queryClient } from "@/queryClient";
import { type BookingForm } from "./bookingForm";
import {
  type Booking,
  type BookingApiResponse,
  parseBookingApiResponse,
} from "./bookings";
import {
  type CreateUpdateBookingRequestBody,
  parseBookingForm,
} from "./createUpdateBookings";

type UpdateBookingRequest = CreateUpdateBookingRequestBody;

export const updateBooking = async (
  bookingId: string,
  formValues: BookingForm,
): Promise<Booking> => {
  const requestBody: UpdateBookingRequest = parseBookingForm(formValues);

  const { body: responseBody } = await api.put<BookingApiResponse>(
    `/bookings/${bookingId}`,
    {
      body: requestBody,
    },
  );

  queryClient.invalidateQueries([BOOKINGS_QUERY_KEY]);

  return parseBookingApiResponse(responseBody);
};
